module.exports = "/_next/static/resources/pack-076f1f0bc61cd5f8376624b81082af8f.jpg";